import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import Icon from "../Icon";
import style from "./style.module.scss";
export default function InlineHelp(props) {
    const { info, children, position } = props;
    let icon = null;
    if (React.Children.count(children) === 0) {
        icon = (_jsx("span", { className: style["inline-help__icon"], children: _jsx(Icon, { name: "help" }) }));
    }
    if (!info) {
        return children;
    }
    let classPosition = "inline-help--none";
    if (position && position === "left") {
        classPosition = "inline-help--left";
    }
    if (position && position === "right") {
        classPosition = "inline-help--right";
    }
    return (_jsxs("div", { className: classNames(style["inline-help"], style[classPosition], "inline-help"), children: [icon, " ", children, _jsx("span", { className: style["inline-help__tool-tip-text"], children: info })] }));
}
